/* Bioniks — bülten popup + footer (Shopify müşteri listesi) */
(function () {
  var COOKIE = 'bioniks_newsletter_dismissed';

  function getCookie(name) {
    var parts = ('; ' + document.cookie).split('; ' + name + '=');
    if (parts.length === 2) return parts.pop().split(';').shift();
    return '';
  }

  function setCookie(name, value, days) {
    var expires = new Date();
    expires.setTime(expires.getTime() + days * 86400000);
    document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/;SameSite=Lax';
  }

  function showMsg(form, html) {
    var box = form.querySelector('.js-newsletter-msg');
    if (!box) return;
    box.innerHTML = html;
    window.setTimeout(function () {
      var alert = box.querySelector('.alert');
      if (alert) alert.style.display = 'none';
    }, 5000);
  }

  function subscribe(email) {
    var body = new URLSearchParams();
    body.append('form_type', 'customer');
    body.append('utf8', '\u2713');
    body.append('contact[email]', email);
    body.append('contact[tags]', 'newsletter');
    body.append('contact[accepts_marketing]', 'true');

    return fetch('/contact', {
      method: 'POST',
      headers: { Accept: 'application/json, text/plain, */*' },
      body: body,
      credentials: 'same-origin'
    });
  }

  function bindForm(form) {
    if (!form || form.dataset.bound === '1') return;
    form.dataset.bound = '1';

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var emailInput = form.querySelector('input[type="email"]');
      var consent = form.querySelector('.js-newsletter-consent');
      var email = (emailInput && emailInput.value || '').trim();

      if (!email) {
        showMsg(form, '<div class="err alert dz-alert alert-danger">Lütfen e-posta adresinizi girin.</div>');
        return;
      }

      if (consent && !consent.checked) {
        showMsg(form, '<div class="err alert dz-alert alert-danger">Devam etmek için onay kutusunu işaretleyin.</div>');
        return;
      }

      showMsg(form, '<div class="gen alert dz-alert alert-success">Gönderiliyor...</div>');

      subscribe(email)
        .then(function (res) {
          if (res.ok) {
            showMsg(form, '<div class="gen alert dz-alert alert-success">Teşekkürler! Bültenimize abone oldunuz.</div>');
            form.reset();
            setCookie(COOKIE, '1', 365);
            var popup = document.getElementById('bioniksNewsletterPopup');
            if (popup) closePopup(popup, popup.dataset.cookieDays || 60);
            return;
          }
          return res.text().then(function (text) {
            if (/already|zaten|subscribed/i.test(text)) {
              showMsg(form, '<div class="gen alert dz-alert alert-success">Bu e-posta zaten kayıtlı. Teşekkürler!</div>');
            } else {
              showMsg(form, '<div class="err alert dz-alert alert-danger">Bir sorun oluştu, lütfen tekrar deneyin.</div>');
            }
          });
        })
        .catch(function () {
          showMsg(form, '<div class="err alert dz-alert alert-danger">Bağlantı hatası, lütfen tekrar deneyin.</div>');
        });
    });
  }

  function closePopup(popup, cookieDays) {
    popup.classList.remove('show');
    popup.classList.add('hidden');
    popup.setAttribute('hidden', 'hidden');
    setCookie(COOKIE, '1', parseInt(cookieDays, 10) || 60);
  }

  function initPopup() {
    var popup = document.getElementById('bioniksNewsletterPopup');
    if (!popup) return;

    var delay = parseInt(popup.dataset.delay, 10);
    if (isNaN(delay)) delay = 5;
    var cookieDays = parseInt(popup.dataset.cookieDays, 10) || 60;

    if (getCookie(COOKIE) === '1') return;

    var form = popup.querySelector('.js-bioniks-newsletter');
    bindForm(form);

    popup.querySelectorAll('.js-newsletter-close').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closePopup(popup, cookieDays);
      });
    });

    popup.addEventListener('click', function (e) {
      if (e.target === popup) closePopup(popup, cookieDays);
    });

    var dialog = popup.querySelector('.modal-dialog');
    if (dialog) {
      dialog.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    window.setTimeout(function () {
      if (getCookie(COOKIE) === '1') return;
      popup.removeAttribute('hidden');
      popup.classList.remove('hidden');
      popup.classList.add('show');
    }, delay * 1000);
  }

  function initFooter() {
    document.querySelectorAll('.js-bioniks-newsletter').forEach(bindForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initPopup();
      initFooter();
    });
  } else {
    initPopup();
    initFooter();
  }
})();
